// extracted by mini-css-extract-plugin
export default {"brandImage":"LiquidSideMenu_brandImage__QndkD"};